import * as React from 'react';
import { Create, CreateProps, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { ELanguage } from '../enums';

export const CoachGuideCategoryCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="name" label="NAME"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
